import React from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import DialogActions from '@mui/material/DialogActions';

import PrimaryCta from 'components/Buttons/PrimaryCta';
import SecondaryCta from 'components/Buttons/SecondaryCta';
import { StyledTypographyColorSectionNavLinkMain } from 'components/Cart/StyledTypographyColorSectionNavLinkMain';
import GroupOrderErrorToast from 'bento-ordering/group_ordering/components/GroupOrderErrorToast';

import { ITEM_DESCRIPTION_AND_PRICES } from 'styles/constants/appearanceSectionNames';
import {
  EMPTY_CART_CONFIRMATION_MODAL,
  LEAVE_GROUP_ORDER_MODAL
} from 'constants/cart';
import { GUEST_CONFIRMATION_BUTTON } from 'bento-ordering/group_ordering/constants/groupOrder';
import { OPACITY_70 } from 'constants/opacity';

import { getHeaderAndNavigationTypography } from 'styles/helpers/getThemeStyles';
import { calculateRgbaWithAlpha } from 'helpers/colorFormatter';

function CartConfirmation({
  onCancel,
  onConfirm,
  groupOrderAdminName,
  modalType = EMPTY_CART_CONFIRMATION_MODAL,
  errorIs404NotFound
}) {
  const isLeaveGroupOrderModal = modalType === LEAVE_GROUP_ORDER_MODAL;
  const styles = { variant: ITEM_DESCRIPTION_AND_PRICES, component: 'h4' };

  const ownMuiEmptyCartStyles = theme => {
    const fontStyles = getHeaderAndNavigationTypography(theme);
    return {
      color: calculateRgbaWithAlpha(
        theme.palette?.button?.background?.hover,
        OPACITY_70
      ),
      ...fontStyles
    };
  };

  const formPrimaryCtaLabel = () => {
    if (isLeaveGroupOrderModal && errorIs404NotFound) {
      return GUEST_CONFIRMATION_BUTTON.error;
    } else if (isLeaveGroupOrderModal) {
      return 'Leave Group Order';
    } else {
      return 'Yes, empty my cart';
    }
  };

  const headerText = isLeaveGroupOrderModal
    ? `Are you sure you want to leave ${groupOrderAdminName}'s Group Order?`
    : 'Are you sure you want to empty your cart?';
  const primaryCtaLabel = formPrimaryCtaLabel();
  const secondaryCtaLabel = isLeaveGroupOrderModal
    ? `Continue Ordering with ${groupOrderAdminName}`
    : 'Return to my cart';

  return (
    <>
      <StyledTypographyColorSectionNavLinkMain
        sx={{
          textAlign: 'center'
        }}
        {...styles}
      >
        {headerText}
      </StyledTypographyColorSectionNavLinkMain>
      {isLeaveGroupOrderModal && <GroupOrderErrorToast />}
      <DialogActions>
        <Box mt={2}>
          <PrimaryCta
            fullWidth
            handleClick={onConfirm}
            label={primaryCtaLabel}
          />
        </Box>

        <Box mt={2}>
          <SecondaryCta
            fullWidth
            label={secondaryCtaLabel}
            disabled={errorIs404NotFound}
            handleClick={onCancel}
            ownState={{
              emptyCart: ownMuiEmptyCartStyles
            }}
          />
        </Box>
      </DialogActions>
    </>
  );
}

CartConfirmation.propTypes = {
  onCancel: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  modalType: PropTypes.string,
  groupOrderAdminName: PropTypes.string,
  errorIs404NotFound: PropTypes.bool.isRequired
};

export default CartConfirmation;
